import React from "react";

// Styles
import GEFSectorsViewContainer from "./GEFSectorsView.styles";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface GEFSectorsViewProps {}

const GEFSectorsView = ({}: GEFSectorsViewProps) => {
    return (
        <GEFSectorsViewContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="2eec0436-c4cd-4fce-9a2b-3f7faa493025"
                    workspaceId="c9679fac-e043-4b12-b47b-d350f81543c1"
                ></PowerBIDashboard>
            </div>
        </GEFSectorsViewContainer>
    );
};
export default GEFSectorsView;
